import React from 'react';
import { Modal } from './ui';

const optionsOf = (list) => (list || []).map(o => (
  <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>
));
const MODES = ['Existing User', 'New User'];

// Super Admin quick "New Event" dialog from the top bar - desktop. Same compact
// layout as the Events page form: name | type, then a segmented Existing / New
// user switch with the user's details on one line. Enter creates.
export default function NewEventModalDesktop({ vm }) {
  const { closeEventModal, eventForm, setEventField, eventTypeOptions, userOptions, savingEvent, addEvent } = vm;
  const mode = eventForm.EventAdminMode || 'Existing User';
  const onEnter = (e) => { if (e.key === 'Enter') { e.preventDefault(); addEvent(); } };

  return (
    <Modal
      className="ev-event-modal"
      title="New Event"
      onClose={closeEventModal}
      footer={<>
        <span className="ev-summary">
          {eventForm.EventName ? <strong>{eventForm.EventName}</strong> : 'Name, type and who runs the event'}
        </span>
        <button className="btn light" type="button" onClick={closeEventModal}>Cancel</button>
        <button className="btn primary" type="button" disabled={savingEvent} onClick={addEvent}>
          {savingEvent ? 'Creating...' : 'Create'}
        </button>
      </>}
    >
      <div className="ev-row ev-event-r1">
        <label className="field">Event Name *
          <input autoFocus value={eventForm.EventName ?? ''} placeholder="e.g. Sahil weds Diksha"
            onChange={(e) => setEventField('EventName', e.target.value)} onKeyDown={onEnter} />
        </label>
        <label className="field">Event Type *
          <select value={eventForm.EventTypeId ?? ''} onChange={(e) => setEventField('EventTypeId', e.target.value)}>
            <option value="">- select -</option>
            {optionsOf(eventTypeOptions)}
          </select>
        </label>
      </div>

      <div className="ev-row ev-event-r2">
        <div className="field ev-admin-label">Event Admin *
          <div className="ev-seg" role="group" aria-label="Event Admin">
            {MODES.map(m => (
              <button key={m} type="button" className={mode === m ? 'on' : ''}
                onClick={() => setEventField('EventAdminMode', m)}>{m}</button>
            ))}
          </div>
        </div>
        {mode === 'New User' ? <span /> : (
          <label className="field">Existing User *
            <select value={eventForm.EventAdminUserId ?? ''} onChange={(e) => setEventField('EventAdminUserId', e.target.value)}>
              <option value="">- select -</option>
              {optionsOf(userOptions)}
            </select>
          </label>
        )}
      </div>

      {mode === 'New User' && (
        <div className="ev-row ev-event-r3">
          <label className="field">New User Name *
            <input value={eventForm.EventAdminName ?? ''} placeholder="Full name"
              onChange={(e) => setEventField('EventAdminName', e.target.value)} onKeyDown={onEnter} />
          </label>
          <label className="field">Mobile *
            <input type="tel" inputMode="numeric" value={eventForm.EventAdminMobileNumber ?? ''} placeholder="10 digits"
              onChange={(e) => setEventField('EventAdminMobileNumber', e.target.value)} onKeyDown={onEnter} />
          </label>
          <label className="field">Password
            <input value={eventForm.EventAdminPassword ?? ''}
              onChange={(e) => setEventField('EventAdminPassword', e.target.value)} onKeyDown={onEnter} />
          </label>
        </div>
      )}
    </Modal>
  );
}
